export const GruposSanguineos = [
  { value: '0-', label: '0-' },
  { value: '0+', label: '0+' },
  { value: 'A-', label: 'A-' },
  { value: 'A+', label: 'A+' },
  { value: 'B-', label: 'B-' },
  { value: 'B+', label: 'B+' },
  { value: 'AB-', label: 'AB-' },
  { value: 'AB+', label: 'AB+' },
];

export const Roles = {
  Alumno: 0,
  Profesor: 1,
  Funcionario: 2,
  Admin: 3,
};

export const EstadosCiviles = [
  { value: 0, label: 'Soltero' },
  { value: 1, label: 'Casado' },
  { value: 2, label: 'Union libre' },
  { value: 3, label: 'Viudo' },
];

export const Generos = [
  { value: 0, label: 'No especificar' },
  { value: 1, label: 'Hombre' },
  { value: 2, label: 'Mujer' },
];

export const Calificaciones = [
  {
    value: undefined, label: '-', desciption: '-', color: 'dark',
  },
  {
    value: null, label: '-', desciption: '-', color: 'dark',
  },
  {
    value: 0, label: 'Ausente', desciption: 'Ausente', color: 'dark',
  },
  {
    value: 1, label: '1: Uno', desciption: 'Uno', color: 'warning',
  },
  {
    value: 2, label: '2: Dos', desciption: 'Dos', color: 'secondary',
  },
  {
    value: 3, label: '3: Tres', desciption: 'Tres', color: 'info',
  },
  {
    value: 4, label: '4: Cuatro', desciption: 'Cuatro', color: 'primary',
  },
  {
    value: 5, label: '5: Cinco', desciption: 'Cinco', color: 'success',
  },
];

export const InstanciaExamen = {
  Final: 0,
  Recuperatorio: 1,
  Invalido: 3,
};

export const EstadoExamen = {
  Activo: { value: 0, label: 'Activo' },
  Sellado: { value: 1, label: 'Sellado' },
  Borrado: { value: 2, label: 'Borrado' },
  Inconsistente: { value: 3, label: 'Inconsistente' },
  ConfirmarNotas: { value: 4, label: 'Confirmar Notas' },
};

export const EstadoMateriaPeriodo = {
  Preliminar: { value: 0, label: 'Preliminar' },
  Publicado: { value: 1, label: 'Publicado' },
  Sellado: { value: 2, label: 'Sellado' },
};

export const InstanciasExamen = [
  { value: 0, label: 'Final' },
  { value: 1, label: 'Recuperatorio' },
  { value: 3, label: 'Invalido' },
];

// 5 MB
export const MaxSizeFile = 5 * 1000000;
export const AcceptTypeFile = ['image/png', 'image/jpeg'];
